import AlertService from '@/shared/alert/alert.service';
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import PdfSNPService from '@/shared/services/snp/pdf.service';
import SolucionService from '@/entities/solucion/solucion.service';
import { Solicitud } from '@/shared/model/solicitud.model';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';
import DocumentoService from '@/components/documentos/documento.service';

@Component
export default class PdfsSolicitudPosgradoComponent extends Vue {
  @Inject('pdfSNPService') private readonly pdfSNPService: () => PdfSNPService;
  @Inject('alertService') private readonly alertService: () => AlertService;
  @Inject('solucionService') private readonly solucionService: () => SolucionService;
  @Inject('documentoService') private readonly documentoService: () => DocumentoService;

  @Prop({ required: true })
  public readonly solicitud: Solicitud;

  public mostrarPdf = false;
  public consultando = false;
  public contenidoBase64 = '';
  public urlActual = '';

  public mostrarCartaRechazo = false;
  public mostrarDocumentoDeReplica = false;

  public mounted(): void {
    this.iniciarComponente();
  }

  public iniciarComponente(): void {
    this.validarMostrarCartaRecahzo();
    this.valiadrMostrarDocumentoReplica();
  }

  @Watch('solicitud')
  private valiadrMostrarDocumentoReplica(): void {
    this.mostrarDocumentoDeReplica = !!this.solicitud.solicitudReplica?.urlDocumento;
  }

  private validarMostrarCartaRecahzo(): void {
    this.solucionService()
      .find(this.solicitud.solucionId)
      .then(resultado => {
        this.mostrarCartaRechazo =
          new Date(resultado?.calendario?.fechaFinSolicitud) < new Date() &&
          [EstadoSolicitud.EN_CAPTURA, EstadoSolicitud.OPERACION_EN_PROCESO].includes(this.solicitud?.estado);
      });
  }

  public generarPdfSolicitudPosgrado(): void {
    this.mostrarPdf = false;
    this.consultando = true;
    this.urlActual = '';

    this.pdfSNPService()
      .exportarSolicitudPosgradoPdf(this.solicitud?.id ?? '')
      .then(responseDocumento => {
        this.contenidoBase64 = `data:application/pdf;base64,${responseDocumento.contenidoBase64}`;
        this.mostrarPdf = true;
      })
      .catch(error => {
        this.mostrarPdf = false;
        this.alertService().showHttpError(this, error.response);
      })
      .finally(() => {
        this.consultando = false;
      });
  }

  public generarReporteCartaRechazoPdf(): void {
    this.mostrarPdf = false;
    this.consultando = true;
    this.urlActual = '';

    this.pdfSNPService()
      .exportarCartaRechazoSolicitudPosgradoPdf(this.solicitud?.id ?? '')
      .then(responseDocumento => {
        this.contenidoBase64 = `data:application/pdf;base64,${responseDocumento.contenidoBase64}`;
        this.mostrarPdf = true;
      })
      .catch(error => {
        this.mostrarPdf = false;
        this.alertService().showHttpError(this, error.response);
      })
      .finally(() => {
        this.consultando = false;
      });
  }

  public generarReporteProfesoresConAlumnosPdf(): void {
    this.mostrarPdf = false;
    this.consultando = true;
    this.urlActual = '';

    this.pdfSNPService()
      .exportarProfesoresConAlumnosSolicitudPosgradoPdf(this.solicitud?.id ?? '')
      .then(responseDocumento => {
        this.contenidoBase64 = `data:application/pdf;base64,${responseDocumento.contenidoBase64}`;
        this.mostrarPdf = true;
      })
      .catch(error => {
        this.mostrarPdf = false;
        this.alertService().showHttpError(this, error.response);
      })
      .finally(() => {
        this.consultando = false;
      });
  }

  public generarReporteAlumnosPorGeneracionPdf(): void {
    this.mostrarPdf = false;
    this.consultando = true;
    this.urlActual = '';

    this.pdfSNPService()
      .exportarAlumnosPorGeneracionSolicitudPosgradoPdf(this.solicitud?.id ?? '')
      .then(responseDocumento => {
        this.contenidoBase64 = `data:application/pdf;base64,${responseDocumento.contenidoBase64}`;
        this.mostrarPdf = true;
      })
      .catch(error => {
        this.mostrarPdf = false;
        this.alertService().showHttpError(this, error.response);
      })
      .finally(() => {
        this.consultando = false;
      });
  }

  public generarDocumentoPorUrl(url: string): void {
    this.mostrarPdf = false;
    this.consultando = true;
    this.urlActual = url;

    this.documentoService()
      .obtenerDocumentoPorUrl(url)
      .then(responseDocumento => {
        this.mostrarPdf = true;
        this.contenidoBase64 = `data:application/pdf;base64,${responseDocumento.contenidoBase64}`;
      })
      .catch(error => {
        this.mostrarPdf = false;
        this.alertService().showHttpError(this, error.response);
      })
      .finally(() => {
        this.consultando = false;
      });
  }
}
